<template>

  <div id="" >
    <van-col span="24" class="invite_share_bg">
      <van-col span="20" offset="2" class="invite_share_top">
        <img src="../assets/img/yaoqingzhuanqian_bac.png"/>
        <van-col span="6" class="invite_share_rules" @click="show = true">{{ $t('share.activity_rules') }}</van-col>
      </van-col>
      <van-col span="22" offset="1" class="invite_share_earnings">
        <van-col span="10" offset="7" class="invite_share_earnings_cumulative_title">{{ $t('share.invitation_income') }}  </van-col>
        <van-col span="18" offset="3" class="invite_share_earnings_cumulative">{{ $t('share.cumulative_income') }} </van-col>
        <van-col span="18" offset="3" class="invite_share_earnings_coin"><span>{{ list.invitation_coin }}</span></van-col>
        <van-col span="18" offset="3" class="invite_share_earnings_user" @click="invite_share_user">{{ $t('share.successfully_invited') }}{{ list.count }}{{ $t('share.individual_users') }} ></van-col>
      </van-col>
      <van-col span="22" offset="1" class="invite_share_way">
        <van-col span="10" offset="7" class="invite_share_earnings_cumulative_title"> {{$t('share.invitation_method')}}</van-col>
        <van-col span="10" offset="1" class="invite_share_way_type" @click="invite_share_btn">
          <van-col span="24" class="invite_share_way_img">
            <img src="../assets/img/yaoqingye.png"/>
          </van-col>
          <van-col span="24" class="invite_share_way_name">{{$t('share.sharing_invitation_page')}}</van-col>
        </van-col>
        <van-col span="10" offset="1" class="invite_share_way_type" @click="invite_share_btn">
          <van-col span="24" class="invite_share_way_img">
            <img src="../assets/img/lianjie.png"/>
          </van-col>
          <van-col span="24" class="invite_share_way_name">{{$t('share.copy_download_link')}}</van-col>
        </van-col>
      </van-col>
      <van-overlay :show="show" @click="show = false">
        <van-col span="20" offset="2" class="overlay_img" @click.stop>
          <van-col span="18" offset="3" v-html="list.rules" class="overlay_center"></van-col>
        </van-col>
      </van-overlay>
    </van-col>
  </div>
</template>
<script>
  //请求接口组件
  import '@/assets/css/style.css'
  import axios from 'axios'
  import Toast from "vant/lib/toast"
  import { Overlay } from 'vant'
  export default {
    name: 'share',
    data:function() {
      return {
        show: false,
        coin:'',
        avatar:'',
        list:[],
        pay_list:[],
        styles:'0'
      }
    },
    components: {
      [Overlay.name]: Overlay
    },
    created: function() {
      this.convert();
      document.title = this.$t('title.invited_share')
    },
    methods: {
      invite_share_btn () {
        // 分享复制
        window.location.href = "cuckoo://invite_share"
      },
      invite_share_user () {
        // 查看邀请的用户
        const token = this.$route.query.token
        const uid = this.$route.query.uid
        this.$router.push({path:'/invited_share_user',query:{token: token, uid: uid }});
      },
      convert: function() {
        var uid = this.$route.query.uid;
        var token = this.$route.query.token;
        axios.get(this.baseUrlApi+"mapi/public/index.php/api/invited_share_api/index_vue",{ params:{ uid:uid,token:token }}).then(res =>{
          console.log(res.data)
          if(res.data.code !=1){
            Toast(res.data.msg)
          }
          this.list = res.data.data
        })
      },
      // 充值 协议
      agreement:function(){
        var uid = this.$route.query.uid;
        var token = this.$route.query.token;
        window.location.href='#/agreement?uid='+uid+'&token='+token;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/invited_share.vue